export default __webpack_public_path__ + "static/noReviewsPlaceholder-bbcf6b8c29d85062612627761040e857.png";